import {isMobile} from '../common/helpers.js';

const init = () => {
    if(!document.querySelector(".ns-demo-payment-page")){
        return;
    }
    const showModalButton = document.querySelector(".ns-demo-payment-page__show-modal-button");
    const closeModalButton = document.querySelector(".ns-demo-payment-page__modal-control-line-close-button");
    const modalLayout = document.querySelector(".ns-demo-payment-page__modal-layout");
    const cardCredentialsButton = document.querySelector(".ns-demo-payment-page__card-detail-button");
    const optionRedirectDesktopType = document.querySelector(".ns-demo-payment-page__iframe-pp-type-desktop-button");
    const optionRedirectMobileType = document.querySelector(".ns-demo-payment-page__iframe-pp-type-mobile-button");
    const cardNumber = document.querySelectorAll(".ns-demo-payment-page__card-detail-info-number");
    const optionRedirect = document.querySelector(".ns-demo-payment-page__option-redirect");
    const optionIframe = document.querySelector(".ns-demo-payment-page__option-iframe");
    const optionMicroframe = document.querySelector(".ns-demo-payment-page__option-microframe");
    const contentContainerOuter = document.querySelector(".ns-demo-payment-page__pp-column-inner-container");
    const redirectContentContainer = document.querySelector(".ns-demo-payment-page__redirect-container");
    const iframeContentContainer = document.querySelector(".ns-demo-payment-page__iframe-init-container");
    const iframePpTypeContainer = document.querySelector(".ns-demo-payment-page__iframe-pp-type-container");
    const microframeContentContainer = document.querySelector(".ns-demo-payment-page__microframe-init-container");
    const microframeSubmitButton = document.querySelector(".ns-demo-payment-page__microframe-pay-button");
    const microframeProcessingButton = document.querySelector(".ns-demo-payment-page__microframe-processing-button");
    const redirectDesktopFrameWidth = "1080px";
    const redirectDesktopFrameHeight = "752px";
    const redirectMobileFrameWidth = "715px";
    const redirectMobileFrameHeight = "1120px";
    const iframeDesktopFrameWidth = "1005px";
    const microframeMaxFrameWidth = "432px";
    const typeOfPaymentInterface = {
        iframe: "ns-demo-payment-page__iframe",
        redirect: "ns-demo-payment-page__redirect",
        microframe: "ns-demo-payment-page__microframe"
    };
    const displayType = {
        mobile: "ns-demo-payment-page__mobile",
        desktop: "ns-demo-payment-page__desktop"
    };

    const setSelectedOption = (typeOfPaymentInterfaceOption) => {
        for (let option in typeOfPaymentInterface) {
            modalLayout.classList.remove(typeOfPaymentInterface[option])
        }
        modalLayout.classList.add(typeOfPaymentInterfaceOption)
    }

    const setDisplayTypeOption = (displayTypeOption) => {
        for (let option in displayType) {
            modalLayout.classList.remove(displayType[option])
        }
        modalLayout.classList.add(displayTypeOption)
    }

    const handleOptionRedirectMobileTypeClick = () => {
        optionRedirectDesktopType.classList.remove("active");
        optionRedirectMobileType.classList.add("active");
        setDisplayTypeOption(displayType.mobile);
        contentContainerOuter.style.maxWidth = redirectMobileFrameWidth;
        redirectContentContainer.style.height = redirectMobileFrameHeight;
    };

    const handleOptionRedirectDesktopTypeClick = () => {
        optionRedirectDesktopType.classList.add("active");
        optionRedirectMobileType.classList.remove("active");
        setDisplayTypeOption(displayType.desktop);
        contentContainerOuter.style.maxWidth = redirectDesktopFrameWidth;
        redirectContentContainer.style.height = redirectDesktopFrameHeight;
    };

    const handleClickOnShow = () => {
        modalLayout.style.display = "block";
        optionRedirect.classList.add("active");
        setSelectedOption(typeOfPaymentInterface.redirect);
        setDisplayTypeOption(displayType.desktop);
        initRedirectMode();
        inertOnModalOn();
    };
    const handleClickOnClose = () => {
        modalLayout.style.display = "none";
        optionRedirect.classList.remove("active");
        optionIframe.classList.remove("active");
        optionMicroframe.classList.remove("active");
        inertOnModalOff();
        clearRedirectContainer();
        clearIframeContainer();
        clearMicroframeContainer();
    };
    const inertOnModalOn = () => {
        const body = document.querySelector('body');
        body.style.overflow  = "hidden";
        // inert on site root elements
        const firstLevelBodyNodes = document.querySelectorAll('body > *');
        firstLevelBodyNodes.forEach((node) => {
            node.setAttribute('inert', 'true');
        });
        const firstLevelMainNodes = document.querySelectorAll('.ns-main > *');
        firstLevelMainNodes.forEach((node) => {
            node.setAttribute('inert', 'true');
        });
        const firstLevelContentNodes = document.querySelectorAll('.ns-content > *');
        firstLevelContentNodes.forEach((node) => {
            node.setAttribute('inert', 'true');
        });
        const modalRootContainerElements = document.querySelectorAll("section.ns-demo-payment-page > div:not(.ns-demo-payment-page__modal-layout)");
        // inert on non-modal filter elements
        modalRootContainerElements.forEach((node) => {
            node.setAttribute('inert', 'true');
        });
        // clear inert on modal tree
        const modalLayout = document.querySelector(".ns-demo-payment-page__modal-layout");
        let modalLayoutParentNode = modalLayout.parentNode;
        while(modalLayoutParentNode.nodeName !== "BODY"){
            modalLayoutParentNode.removeAttribute('inert');
            modalLayoutParentNode = modalLayoutParentNode.parentNode;
        }
        // focus on first modal element
        closeModalButton.focus();
    };

    const inertOnModalOff = () => {
        const body = document.querySelector('body');
        body.style.overflow = "auto";
        const firstLevelBodyNodes = document.querySelectorAll('body > *');
        firstLevelBodyNodes.forEach((node) => {
            node.removeAttribute('inert');
        });
        const firstLevelMainNodes = document.querySelectorAll('.ns-main > *');
        firstLevelMainNodes.forEach((node) => {
            node.removeAttribute('inert');
        });
        const firstLevelContentNodes = document.querySelectorAll('.ns-content > *');
        firstLevelContentNodes.forEach((node) => {
            node.removeAttribute('inert');
        });
        const modalRootContainerElements = document.querySelectorAll("section.ns-demo-payment-page > div:not(.ns-demo-payment-page__modal-layout)");
        // inert on non-modal filter elements
        modalRootContainerElements.forEach((node) => {
            node.removeAttribute('inert');
        });
    };

    const handleCardCredentialsClick = (e) => {
        const parentContainer = e.currentTarget.parentNode;
        if(parentContainer.classList.contains("open")){
            parentContainer.classList.remove("open");
            e.currentTarget.setAttribute('aria-expanded', "false");
        }
        else{
            parentContainer.classList.add("open");
            e.currentTarget.setAttribute('aria-expanded', "true");
        }
    };

    const handleCardCredentialsClose = (e) => {
        const cardInfoContainer = document.querySelector(".ns-demo-payment-page__card-detail-container");
        let element = e.target
        let isCardContainer = false;
        while(element.nodeName !== "BODY"){
            if(element.classList.contains("ns-demo-payment-page__card-detail-container")){
                isCardContainer = true;
                break;
            }
            element = element.parentNode;
        }
        if(!isCardContainer && cardInfoContainer.classList.contains("open") ){
            cardInfoContainer.classList.remove("open");
        }
    }

    const handleCardNumberClick = (e) => {
        if(window.isSecureContext){
            const textToCopy = e.target.parentNode.textContent.trim();
            navigator.clipboard.writeText(textToCopy);
        }
        else{
            console.log("Operations with clipboard are insecure");
        }
    };

    const initRedirectMode = async () => {
        if(window.innerWidth > 1110){
            handleOptionRedirectDesktopTypeClick();
        }
        else{
            handleOptionRedirectMobileTypeClick();
        }
        const response = await fetch("/ajax/generate-demo-payment-page-link/", {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        });
        const { linkToRedirect } = await response.json();
        const redirectIframe = document.createElement("iframe");
        redirectIframe.setAttribute("src", linkToRedirect);
        redirectContentContainer.appendChild(redirectIframe);
        redirectContentContainer.style.display = "block";
        iframeContentContainer.parentNode.parentNode.style.display = "none";
        microframeContentContainer.parentNode.style.display = "none";
    };

    const initIframeMode = async () => {
        const response = await fetch("/ajax/generate-demo-payment-page-config-obj-iframe/", {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        });
        const { configObj } = await response.json();
        EPayWidget.run(JSON.parse(configObj), 'POST');
        contentContainerOuter.style.maxWidth = iframeDesktopFrameWidth;
        redirectContentContainer.style.display = "none";
        iframeContentContainer.parentNode.parentNode.style.display = "flex";
        microframeContentContainer.parentNode.style.display = "none";
    };

    const initMicroframeMode = async () => {
        const response = await fetch("/ajax/generate-demo-payment-page-config-obj-microframe/", {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        });
        const { configObj } = await response.json();
        const config = JSON.parse(configObj);

        EPayWidget.run(config, 'POST');
        contentContainerOuter.style.maxWidth = microframeMaxFrameWidth;
        redirectContentContainer.style.display = "none";
        iframeContentContainer.parentNode.parentNode.style.display = "none";
        microframeContentContainer.parentNode.style.display = "block";
    };


    const clearRedirectContainer = () => {
        while (redirectContentContainer.firstChild) {
            redirectContentContainer.removeChild(redirectContentContainer.lastChild);
        }
    }
    const clearIframeContainer = () => {
        while (iframeContentContainer.firstChild) {
            iframeContentContainer.removeChild(iframeContentContainer.lastChild);
        }
    }
    const clearMicroframeContainer = () => {
        while (microframeContentContainer.firstChild) {
            microframeContentContainer.removeChild(microframeContentContainer.lastChild);
        }
    }

    const handleOptionRedirectClick = () => {
        if(optionRedirect.classList.contains("active")){
            return;
        }
        clearRedirectContainer();
        clearIframeContainer();
        clearMicroframeContainer();
        optionRedirect.classList.add("active");
        optionIframe.classList.remove("active");
        optionMicroframe.classList.remove("active");
        iframePpTypeContainer.style.display = "block";
        setSelectedOption(typeOfPaymentInterface.redirect);
        initRedirectMode();
    }

    const handleOptionIframeClick = () => {
        if(optionIframe.classList.contains("active")){
            return;
        }
        clearRedirectContainer();
        clearIframeContainer();
        clearMicroframeContainer();
        optionRedirect.classList.remove("active");
        optionIframe.classList.add("active");
        optionMicroframe.classList.remove("active");
        iframePpTypeContainer.style.display = "none";
        setSelectedOption(typeOfPaymentInterface.iframe);
        initIframeMode();
    }

    const handleOptionMicroframeClick = () => {
        if(optionMicroframe.classList.contains("active")){
            return;
        }
        clearRedirectContainer();
        clearIframeContainer();
        clearMicroframeContainer();
        microframeSubmitButton.style.display = "block";
        microframeProcessingButton.style.display = "none";
        optionRedirect.classList.remove("active");
        optionIframe.classList.remove("active");
        optionMicroframe.classList.add("active");
        iframePpTypeContainer.style.display = "none";
        setSelectedOption(typeOfPaymentInterface.microframe);
        initMicroframeMode();
    }

    //swiping

    const transformPosition = (event) => {
        if(window.innerWidth > 600){
            return;
        }
        let clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        if(window.swipeStartPosition && event.currentTarget.clientWidth != event.currentTarget.scrollWidth){
            window.oldOffsetElement = window.offsetElement;
            if(!window.offsetElement){
                window.offsetElement = 0;
            }
            if(!window.prevClientX){
                window.prevClientX = clientX;
                window.offsetElement -= 1;
            }
            else{
                window.offsetElement -= window.prevClientX - clientX;
                if(event.currentTarget.scrollWidth - event.currentTarget.clientWidth < Math.abs(window.offsetElement)){
                    window.offsetElement = window.oldOffsetElement;
                    return;
                }
                window.prevClientX = clientX;
            }
            if(window.offsetElement > 0){
                window.offsetElement = 0;
            }
            event.currentTarget.style.transform = `translateX(${window.offsetElement}px)`;
        }
    }
    const dropTransformPosition = (event) => {
        event.currentTarget.style.transform = "translateX(0px)";
        delete window.swipeStartPosition;
        delete window.offsetElement;
        delete window.offsetElement;
    }
    const markSwipeStart = (event) => {
        let clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        window.swipeStartPosition = clientX;
        event.currentTarget.style.transition = "0ms";
    }
    const markSwipeEnd = (event) => {
        let clientX = event.clientX ? event.clientX : event.changedTouches[0].clientX;
        if(window.swipeStartPosition === clientX){
            let link = event.target;
            while(typeof link.href === "undefined"){
                link = link.parentNode;
                if(link === document){
                    break;
                }
            }
            if (typeof link.href !== "undefined") {
                window.location.assign(link.href);
            }
        }
        delete window.swipeStartPosition;
        delete window.prevClientX;
        event.currentTarget.style.transition = null;
    }

    document.querySelectorAll(".ns-demo-payment-page__options-column").forEach((target) => {
        target.addEventListener("mousemove", transformPosition, true);
        target.addEventListener("mouseleave", dropTransformPosition, false);
        target.addEventListener("mousedown", markSwipeStart, false);
        target.addEventListener("mouseup", markSwipeEnd, false);

        target.addEventListener("touchmove", transformPosition, true);
        target.addEventListener("touchstart", markSwipeStart, false);
        target.addEventListener("touchend", markSwipeEnd, false);
    });


    showModalButton.addEventListener("click", handleClickOnShow);
    closeModalButton.addEventListener("click", handleClickOnClose);
    cardCredentialsButton.addEventListener("click", handleCardCredentialsClick);
    modalLayout.addEventListener("click", handleCardCredentialsClose);
    cardNumber.forEach((item) => {
        item.addEventListener("click", handleCardNumberClick);
    });
    optionRedirectMobileType.addEventListener("click", handleOptionRedirectMobileTypeClick);
    optionRedirectDesktopType.addEventListener("click", handleOptionRedirectDesktopTypeClick);
    optionRedirect.addEventListener("click", handleOptionRedirectClick);
    optionIframe.addEventListener("click", handleOptionIframeClick);
    optionMicroframe.addEventListener("click", handleOptionMicroframeClick);

    window.addEventListener(
        "message",
        (event) => {
            if (event.origin !== "https://paymentpage.ecommpay.com"){
                return;
            }
            const errorContainer = document.querySelector(".ns-demo-payment-page__microframe-errors-container");
            const iframe = document.querySelector(".ns-demo-payment-page__microframe-init-container iframe");
            const iframeContainer = document.querySelector(".ns-demo-payment-page__microframe-init-container");
            const data = JSON.parse(event.data);
            if(data.message === "epframe.validation.status.change"){
                let errorMessage = "";
                for (let key in data.data){
                    errorMessage += `${data.data[key]} `;
                }
                if(errorMessage !== ""){
                    console.error(errorMessage);
                    errorContainer.innerHTML = errorMessage;
                }
            }
            if(data.message === "epframe.payment.sent"){
                microframeProcessingButton.style.display = "block";
                microframeSubmitButton.style.display = "none";
                errorContainer.innerHTML = "";
            }
            if(data.message === "epframe.payment.success"){
                iframe.style.display = "none";
                clearMicroframeContainer();
                iframeContainer.style.color = "#3bf100";
                iframeContainer.innerHTML = "Payment Success";
            }
            if(data.message === "epframe.redirect_iframe"){
                microframeProcessingButton.style.display = "none";
                iframe.style.margin = "auto";
                iframe.style.height = "326px";
            }
        },
        false,
    );

    const fixRedirectFrameHeightOnResize = () => {
        if(optionRedirect.classList.contains("active")){
            if(window.innerWidth > 1110){
                handleOptionRedirectDesktopTypeClick();
            }
            else{
                handleOptionRedirectMobileTypeClick();
            }
        }
    };

    window.addEventListener("resize", fixRedirectFrameHeightOnResize, false);
}
window.addEventListener("DOMContentLoaded", init, false);
